import React from 'react';
import { observer } from 'mobx-react-lite';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export default observer(function CloseButton({
  onClick,
}: {
  onClick: () => void;
}) {
  return (
    <IconButton sx={{ color: 'primary.contrastText' }} onClick={onClick}>
      <CloseIcon color="inherit"></CloseIcon>
    </IconButton>
  );
});
